export enum KnowEdmTableData {
  Tvd = 'depthTVD', // tvd
  PorePressure = 'value', // pore_pressure
  PorePressureGradient = 'gradient', // pore_pressure_emw
  FracturePressure = 'value', // frac_gradient_emw
  FracturePressureGradient = 'gradient', // frac_gradient_pressure
  CollapsePressure = 'value',
  CollapsePressureGradient = 'gradient',
  MinimumHorizontalStressPressure = 'value',
  MinimumHorizontalStressPressureGradient = 'gradient',
}
